import { jsx as _jsx } from "preact/jsx-runtime";
import { THEME_COLORS } from '@/constants/theme';
// Reusable signal strength bar visualization (5 bars, bucketed by score/4 by default)
export const SignalBars = ({ score, totalBars = 5, barHeightPercent = 85, class: className = 'flex items-end h-10 w-16 gap-1', ariaLabelPrefix = 'Signal strength' }) => {
    const activeBars = Math.min(totalBars, Math.max(0, Math.ceil(score / 4)));
    const colors = [THEME_COLORS.PURPLE[400], THEME_COLORS.PURPLE[400], THEME_COLORS.PURPLE[500], THEME_COLORS.PURPLE[500], THEME_COLORS.PURPLE[800]];
    return (_jsx("div", { class: className, "aria-label": `${ariaLabelPrefix} ${activeBars} of ${totalBars} (score ${score})`, title: `Signal score ${score}`, children: Array.from({ length: totalBars }).map((_, i) => {
            const filled = i < activeBars;
            const baseClass = filled ? 'flex-1 rounded-sm transition-colors duration-300' : 'flex-1 rounded-sm transition-colors duration-300 bg-gray-200 dark:bg-gray-700';
            return (_jsx("div", { class: baseClass, style: {
                    height: `${barHeightPercent}%`,
                    minWidth: '5px',
                    backgroundColor: filled ? colors[i] : undefined
                } }, i));
        }) }));
};
export default SignalBars;
